import clsx from 'clsx';
import React from 'react';

interface BadgeProps {
  text: string;
  variant: 'success' | 'danger' | 'info' | 'warning' | 'primary' | 'secondary';
  className?: string;
  style?: any;
  badgeTag?: boolean;
  onClick?: () => void;
}

const Badge: React.FC<BadgeProps> = ({ text, variant, className, style, badgeTag, onClick }) => {
  if (badgeTag) {
    return (
      <span
        className={clsx(`badge bg-label-${variant} border border-dashed border-${variant} rounded-2`, className, { 'cursor-pointer': !!onClick })}
        style={style}
        onClick={onClick}
      >
        {text}
      </span>
    );
  }

  return (
    <span
      className={clsx(`badge ${!style && 'rounded-pill'} bg-${variant} ${className}`)}
      style={style}
    >
      {text}
    </span>
  );
};

export default Badge;
